
import axios from "axios";
import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from "react-bootstrap/Spinner";
import InputLabel from '@mui/material/InputLabel';
import { Icon } from "@iconify/react";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { Button, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Box } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Typography from '@mui/material/Typography';
import * as moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import settings from "../helpers/Settings";
let { KayanURL } = settings;

class BatchSubmission extends Component {

    constructor(props) {
        super(props);
        this.state = {
      claims:[]

        };
    }

    componentDidMount = async () => {
    this.setState({allClaims:JSON.parse(localStorage.getItem("claims"))})

    };
    HandleInputTextChange = (e) => {
        this.setState( { [e.target.name]: e.target.value });
      };
      HandleDateChange = (e) => {
        let date = moment(e.value.$d).format('YYYY-MM-DD')
        this.setState({ [e.name]: date })
      }
      handleCheckBox = async (e, index) => {
        let {claims,allClaims } = this.state;
        if (e.target.checked) {
          claims.push(allClaims[index]);
        } else {
          claims.splice(index, 1);
        }
      };
      handleSubmitBatch = async (e)  =>{
        console.log(this.state)
        e.preventDefault();
        this.setState({ RequestSent: true, checkResponse: false });
        let BatchSubmissionResponse = await axios.post(
          //KayanURL + "api/KSA/RCM/request",
          "http://141.147.130.248:4000/api/KSA/RCM/request",
          {
            apiToken: "token",
            requestType: "4",
            payerID: this.state.payer,
            providerID: "10000300178702",
            batchPeriodFrom:this.state.batchPeriodFrom,
            batchPeriodTo:this.state.batchPeriodTo,
            claims: this.state.claims,
            codingSystem:"internal"
          }
        );
        if (BatchSubmissionResponse) {
          console.log(BatchSubmissionResponse)
          this.setState({
            RequestSent: false,
            checkResponse: true,
          });
          let { data } = BatchSubmissionResponse;
          if (data) {
            let { success, response,error,ClaimBundleIDs,BatchBundleID} = data;
            if (success) {
              let res = JSON.parse(response);
              console.log('res,BatchBundleID:',res,BatchBundleID)
              this.setState({res,success,BatchBundleID})
              let {entry} = res
              if (entry && entry.length > 0) {
                let MessageHeader = entry.filter((element) => {
                  return element["resource"]["resourceType"] == "MessageHeader";
                });
                if(MessageHeader && MessageHeader.length>0){
                  let {focus} = MessageHeader[0]["resource"]
                  for(let i=0;i<focus.length;i++){
                  let arrayForqueuedData=[];
                  let arrayData = [];
                    let focusJson = entry.filter((element) => {
                      return element["fullUrl"] == focus[i]["reference"];
                    });
                    if(focusJson && focusJson.length>0){
                      let entryChild = focusJson[0]["resource"]["entry"]
                      let claimResponse = entryChild.filter((element) => {
                        return element["resource"]["resourceType"] == "ClaimResponse";
                      });
                      console.log('claimResponse:',claimResponse)
                      if(claimResponse && claimResponse.length>0){
                        let outcome = claimResponse[0]["resource"]["outcome"];
                      console.log("outcome", outcome);
                      if (outcome == "error") {
                        let errors = claimResponse[0]["resource"]["error"];
                        this.setState({ errors });
                      } else if (outcome == "complete") {
                        let items = []
                        let Total = []
                        let { item, total,preAuthPeriod,preAuthRef} = claimResponse[0]["resource"];
                        let PreAuthPeriod;
                    if (preAuthPeriod) {
                      let startDateOfPreAuth =
                        preAuthPeriod["start"].split("-")[2] +
                        "/" +
                        preAuthPeriod["start"].split("-")[1] +
                        "/" +
                        preAuthPeriod["start"].split("-")[0];
                      let EndDateOfPreAuth =
                        preAuthPeriod["end"].split("-")[2] +
                        "/" +
                        preAuthPeriod["end"].split("-")[1] +
                        "/" +
                        preAuthPeriod["end"].split("-")[0];
                      PreAuthPeriod =
                        startDateOfPreAuth + " to " + EndDateOfPreAuth;
                    }
                    for (let j = 0; j < item.length; j++) {
                      let reason;
                      let adjudications = [];
                      let { adjudication } = item[j];
                      for (let i = 0; i < adjudication.length; i++) {
                        if (
                          adjudication[i]["category"]["coding"][0]["code"] !=
                          "approved-quantity"
                        ) {
                          adjudications.push({
                            category:
                              adjudication[i]["category"]["coding"][0]["code"],
                            amount:
                              adjudication[i]["amount"]["value"] +
                              adjudication[i]["amount"]["currency"],
                          });
                        } else {
                          adjudications.push({
                            category:
                              adjudication[i]["category"]["coding"][0]["code"],
                            amount: adjudication[i]["value"],
                          });
                        }
                        if (adjudication[i]["reason"]) {
                          reason =
                            adjudication[i]["reason"]["coding"][0]["display"];
                          this.setState({ reason });
                        }
                      }
                      items.push({
                        itemSequence: item[j]["itemSequence"],
                        outcome:
                          item[j]["extension"][0]["valueCodeableConcept"][
                            "coding"
                          ][0]["code"],
                        adjudications,
                      });
                    }
                    console.log('items',items);
                    this.setState({ items });
                    for (let i = 0; i < total.length; i++) {
                      Total.push({
                        category: total[i]["category"]["coding"][0]["code"],
                        amount:
                          total[i]["amount"]["value"] +
                          total[i]["amount"]["currency"],
                      });
                    }
                    const totalRows = Total.map((element, index) => {
                      return (
                        <tr key={index}>
                          <td>{element.category}</td>
                          <td>{element.amount}</td>
                        </tr>
                      );
                    });
                    let displayData = {
                      outcome:outcome,
                      ksaMessageEvents: claimResponse[0]["resource"]["eventCoding"]["code"],
                      ResponseBuisnessIdentifier:
                        claimResponse[0]["resource"]["identifier"][0]["value"],
                      adjudicationOutcome:
                        claimResponse[0]["resource"]["extension"][0][
                          "valueCodeableConcept"
                        ]["coding"][0]["code"],
                      requestIdentifier:
                        claimResponse[0]["resource"]["request"]["identifier"]["value"],
                      preAuthRef: preAuthRef ? preAuthRef:"",
                      PreAuthPeriod: PreAuthPeriod ? PreAuthPeriod :"",
                      items,
                      Total,
                    };
                    arrayData.push(displayData);
                    console.log('arraydata:',arrayData)
                    this.setState({ arrayData, totalRows, outcome});
                      }else if (outcome == "queued") {
                        if(ClaimBundleIDs && ClaimBundleIDs.length>0){
                          for(let i=0;i<ClaimBundleIDs.length;i++){
                            arrayForqueuedData.push({outcome,bundleId:ClaimBundleIDs[i]})
                          }
                        this.setState({ outcome,arrayForqueuedData});
    
                        }
                      }
                    }
                    }
                  }
                }
              }
           }
        else {
          this.setState({ error });
          console.log(error);
        }
      }
        }
      }
    render() {
    let {allClaims,
      arrayForqueuedData,
      checkResponse,
      RequestSent,
      success,
      arrayData
      ,reason
      ,items,} = this.state
   let allClaimsRows
  if(allClaims && allClaims.length >0){
    allClaimsRows = allClaims.map((element, index) => {
      return (
        <TableRow key={index}>
          <TableCell align="center">
          <Checkbox name="online"
            onChange={(e) => this.handleCheckBox(e, index)}
            />
          </TableCell>
          <TableCell align="center">{index+1}</TableCell>
          <TableCell align="center" style={{fontSize:"small"}}>{element.claimType}</TableCell>
        </TableRow>
      );
    });
  }
  let queuedRows
  if(arrayForqueuedData && arrayForqueuedData.length>0){
    queuedRows = arrayForqueuedData.map((element ,index) =>{
      return (
        <TableRow key={index}>
            <TableCell align="center">{index + 1}</TableCell>
            <TableCell align="center">{element.outcome}</TableCell>
            <TableCell align="center">
              The claim for the selected activities is qeued ,
              try to pull the response anothertime ,and the bundle id is{" "}
              {element.bundleId}
            </TableCell>
        </TableRow>
      )
    })
  }
  const itemRows = items?.map((element, index) => {
    const adjudicationRows = element.adjudications?.map((element, index) => {
      return (
        <TableRow key={index}>
          <TableCell align="center">{element.category}</TableCell>
          <TableCell align="center">{element.amount}</TableCell>
        </TableRow>
      );
    });
    return (
      <TableRow key={index}>
        <TableCell align="center">{element.itemSequence}</TableCell>
        <TableCell align="center">{element.outcome}</TableCell>
        {reason ? <TableCell align="center">{element.reason}</TableCell> : null}
        <TableCell style={{ padding: "0" }}>
        <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead style={{ backgroundColor: "#fafafa" }}>
              <TableRow style={{ textAlign: 'center' }}>
                <TableHead align="center">category</TableHead>
                <TableHead align="center">amount</TableHead>
              </TableRow>
            </TableHead>
            <TableBody>{adjudicationRows}</TableBody>
          </Table>
          </TableContainer>
        </TableCell>
      </TableRow>
    );
  });
  let dataRows;
  if (arrayData && arrayData.length) {
    dataRows = arrayData.map((element, index) => {
      return (
        <TableRow key={index}>
            <TableCell align="center">{index + 1}</TableCell>
            <TableCell align="center">{element.outcome}</TableCell>
            <TableCell align="center">{element.ksaMessageEvents}</TableCell>
            <TableCell align="center">{element.ResponseBuisnessIdentifier}</TableCell>
            <TableCell align="center">{element.adjudicationOutcome}</TableCell>
            <TableCell align="center">{element.requestIdentifier}</TableCell>
            <TableCell align="center">{element.preAuthRef}</TableCell>
            <TableCell align="center">{element.preAuthPeriod}</TableCell>
            <TableCell align="center" style={{ padding: "0" }}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead style={{ backgroundColor: "#fafafa" }}>
                  <TableRow style={{ textAlign: 'center' }}>
                    <TableHead align="center">itemSequence</TableHead>
                    <TableHead align="center">outcome</TableHead>
                    {reason ? <TableHead align="center">Reason</TableHead> : null}
                    <TableHead align="center">adjudication</TableHead>
                  </TableRow>
                </TableHead>
                <TableBody>{itemRows}</TableBody>
              </Table>
              </TableContainer>
            </TableCell>
            <TableCell align="center">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead style={{ backgroundColor: "#fafafa" }}>
                  <TableRow style={{ textAlign: 'center' }}>
                    <TableHead align="center">category</TableHead>
                    <TableHead align="center">amount</TableHead>
                  </TableRow>
                </TableHead>
                <TableBody>{this.state.totalRows}</TableBody>
              </Table>
              </TableContainer>
            </TableCell>
          
        </TableRow>
      );
    });
  }
        return (
            <>
        <Box height={60} />
                    <div style={{
                            textAlign: "left",
                            boxShadow: "1px solid grey",
                            boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
                            borderRadius: "10px",
                            paddingBottom:"20px",
                          }}>
                        <Container style={{width:"50%"}}>
                            <Row style={{padding:"40px"}}>
                            <Typography id="modal-modal-title" variant="h6" component="h2" style={{marginBottom:"20px" }}>
                        Batch Submission
                      </Typography>
                                <FormControl fullWidth sx={{ mb: 3 }} >
                                        <InputLabel id="insurance" style={{ fontSize: "small" }}>Payer ID </InputLabel>
                                        <Select
                                            required
                                            labelId="insurance"
                                            name="payer"
                                            label="Payer ID"
                                            onChange={this.HandleInputTextChange}
                                            style={{ height: "45px" }}
                                        >
                                            <MenuItem value="INS-FHIR" style={{ fontSize: "small" }}>Pseudo Payer</MenuItem>

                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth sx={{ mb: 3, }}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs} >

                                            <DatePicker
                                                sx={{
                                                    "& .MuiInputBase-input": {
                                                        height: "12px",
                                                    },
                                                    ".css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
                                                        fontSize: 'small',
                                                    },
                                                }}
                                                name="batchPeriodFrom"
                                                label="Batch Period From"
                                                onChange={(date) => this.HandleDateChange({ name: "batchPeriodFrom", value: date })} />
                                        </LocalizationProvider>
                                    </FormControl>
                                    <FormControl fullWidth sx={{ mb: 3, }}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs} >

                                            <DatePicker
                                                sx={{
                                                    "& .MuiInputBase-input": {
                                                        height: "12px",
                                                    },
                                                    ".css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
                                                        fontSize: 'small',
                                                    },
                                                }}
                                                name="batchPeriodTo"
                                                label="Batch Period To"
                                                onChange={(date) => this.HandleDateChange({ name: "batchPeriodTo", value: date })} />
                                        </LocalizationProvider>
                                    </FormControl>
                                
                                    {allClaims && allClaims.length >0 ? (
                                        <>
                                 <div style={{  margin: "20px 0" , width:"100%",padding:"0" }}>
                                                  
                               <TableContainer component={Paper} style={{padding:"0",width:"100%"}} >
                          <Table aria-label="simple table">
                            <TableHead style={{ backgroundColor: "#fafafa" }}>
                              <TableRow style={{ textAlign: 'center' }}>
                                <TableCell align="center"></TableCell>
                                <TableCell align="center">ID</TableCell>
                                <TableCell align="center">Claim Type</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {allClaimsRows}
                            </TableBody>
                          </Table>
                        </TableContainer>
                                            </div>
                                        </>
                           ):null}
                                    <Button variant="contained" style={{ backgroundColor: "rgb(97 110 120", width: "150px" }}
                                    onClick={(e) => this.handleSubmitBatch(e)}
                                >Submit Batch</Button>
                                
                            </Row>
                            
                        </Container>
                  {RequestSent && !checkResponse ? (
                        <div style={{textAlign:"center",marginTop:"10px"}}>
                        <Spinner animation="border" variant="success"  />
                          </div>
                      ) : !success ? (
                        <h5 style={{ color: "red" }}>{this.state.error}</h5>
                      ) : success  ? (
                          <div style={{ textAlign: "center" }}>
                        {this.state.BatchBundleID ? (<Typography id="modal-modal-title"
                         variant="h6" component="h2" 
                         style={{ textAlign: "center",
                          marginTop: "5px",
                          marginBottom:"10px", 
                          fontSize: "small" }}>
                            The request bundle ID is: {this.state.BatchBundleID}
                            </Typography>) : null}
                        </div>
                      ):null}
                      {arrayData && arrayData.length > 0 ? (
                      <>
                        <div style={{ width: "98%", overflowX: "scroll" }}>
                        <TableContainer component={Paper} style={{padding:"0",width:"100%"}} >
                        <Table aria-label="simple table">
                        <TableHead style={{ backgroundColor: "#fafafa" }}>
                              <TableRow style={{ textAlign: 'center' }}>
                                <TableCell align="center">Id</TableCell>
                                <TableCell align="center">outcome</TableCell>
                                <TableCell align="center">ksa Message Events</TableCell>
                                <TableCell align="center">Response Buisness Identifier</TableCell>
                                <TableCell align="center">Adjudication Outcomee</TableCell>
                                <TableCell align="center">Request Identifier</TableCell>
                                <TableCell align="center">preAuthRef</TableCell>
                                <TableCell align="center">PreAuthPeriod</TableCell>
                                <TableCell align="center">Items</TableCell>
                                <TableCell align="center">Total</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>{dataRows}</TableBody>
                          </Table>
                          </TableContainer>
                        </div>
                      </>
                    ) : null}
                {arrayForqueuedData && arrayForqueuedData.length>0 ? (
                      <>
                        <div style={{ width: "70%",margin:"auto",marginBottom:"20px" }}>
                        <TableContainer component={Paper} style={{padding:"0",width:"100%"}} >
                          <Table aria-label="simple table">
                            <TableHead style={{ backgroundColor: "#fafafa" }}>
                              <TableRow style={{ textAlign: 'center' }}>
                                <TableCell align="center">ID</TableCell>
                                <TableCell align="center">Outcome</TableCell>
                                <TableCell align="center">BundleID</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {queuedRows}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        </div>
                      </>
                    ):null}
                    </div>
         </>
        );
    }
}

export default BatchSubmission;